import clsx from 'clsx';
import { motion } from 'framer-motion';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import Title from '@/assets/components/loader/title.svg?react';

import styles from './Loader.module.scss';

export const Loader = observer(() => {
  const [activeIndex, setActiveIndex] = useState(0);
  const totalCircles = 8;

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % totalCircles);
    }, 200);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={clsx(styles.loader, 'in-col-center')}>
      <Title />
      <div className={styles.container}>
        {Array.from({ length: totalCircles }).map((_, index) => {
          const isActive = index === activeIndex;
          const isActiveLeft = index === (activeIndex - 1) % totalCircles;
          const isActiveRight = index === (activeIndex + 1) % totalCircles;
          const isLast =
            index === (activeIndex + totalCircles / 2) % totalCircles;

          const isLastLeft =
            index === (activeIndex - 1 + totalCircles / 2) % totalCircles;
          const isLastRight =
            index === (activeIndex + 1 + totalCircles / 2) % totalCircles;

          return (
            <motion.div
              key={index}
              className={clsx(styles.circle, styles[`circle-${index}`])}
              animate={{
                opacity: isActive
                  ? 1
                  : isActiveLeft || isActiveRight
                    ? 0.8
                    : isLastLeft || isLastRight
                      ? 0.4
                      : isLast
                        ? 0.2
                        : 0.6,
              }}
              transition={{ duration: 0.2 }}
            />
          );
        })}
      </div>
    </div>
  );
});
